// IMPORTANT !!
// Make sure we have config - the config service expects it and we can't import any service before it
if (!window.cpxConfig) {
	throw new Error('Config not found on window');
}

require('./app.jsx');
